import { Builder } from '@builder.io/react';

import 'react-scale/components/sections/announcement-banner/announcement-banner.builder';
import 'react-scale/components/sections/events-banner/events-banner.builder';

const OVERRIDE_INSERT_MENU = true;

if (OVERRIDE_INSERT_MENU) {
  // (optionally) use this to hide all default built-in components and fully manage
  // the insert menu components and sections yourself
  Builder.register('editor.settings', { customInsertMenu: true });
}

Builder.register('insertMenu', {
  name: 'Banners',
  items: [{ name: 'EventsBanner' }, { name: 'AnnouncementBanner' }]
});
